<div class="cell xsmall-24 large-12 grid-y align-middle">
    <h1 class="cell shrink _primary archetypeTitle"[i18nKey]="'decisions.archetype.title'"></h1>

    <div class="cell shrink archetypeDescription">
        <div class="archetypeDescription-item">
            <i class="archetypeDescription-item-icon fas fa-unlock-alt"></i>
            <p class="archetypeDescription-item-text archetype-tooltipContainer"
               [innerHTML]="'decisions.archetype.description.1'|translate" [i18nKey]="[{target: 'innerHTML', key: 'decisions.archetype.description.1'}]"></p>
            <p class="archetype-label" [innerHTML]="'decisions.archetype.description.detail'|translate" [i18nKey]="[{target: 'innerHTML', key: 'decisions.archetype.description.detail'}]"></p>
        </div>
        <div class="archetypeDescription-item">
            <i class="archetypeDescription-item-icon fas fa-star"></i>
            <p class="archetypeDescription-item-text"
               [innerHTML]="'decisions.archetype.description.2'|translate" [i18nKey]="[{target: 'innerHTML', key: 'decisions.archetype.description.2'}]"></p>
        </div>
        <div class="archetypeDescription-item">
            <i class="archetypeDescription-item-icon fas fa-tasks"></i>
            <p class="archetypeDescription-item-text"
               [innerHTML]="'decisions.archetype.description.3'|translate" [i18nKey]="[{target: 'innerHTML', key: 'decisions.archetype.description.3'}]"></p>
        </div>
    </div>
</div>

<div class="cell xsmall-24 large-12" *ngIf="!!parameters && !!parameters.archetypes">
    <div class="cell shrink archetypeContainer-content">
        <ngx-slick-carousel class="archetypeCarousel carousel"
                            #slickModal="slick-carousel"
                            [config]="slideConfig"
                            (afterChange)="afterChange($event)">
            <div ngxSlickItem *ngFor="let archetypeName of parameters.archetypes"
                 class="archetypeContainer-content-item slide"
                 (click)="onSelect(archetypeName)"
                 [class._active]="selectedArchetype == archetypeName">
                <div class="archetypeImg" [ngClass]="archetypeName"></div>
                <span class="archetypeName">{{('decisions.archetype.' + archetypeName) | translate}}</span>
                <p class="archetypeDescription">
                    {{
                        'decisions.archetype.' + archetypeName + '.description' | translate :
                        {
                            limitBetweenType1AndType2: parameters.limitBetweenType1AndType2,
                            limitBetweenType2AndType3: parameters.limitBetweenType2AndType3
                        }
                    }}
                </p>
            </div>
        </ngx-slick-carousel>
    </div>

    <div class="cell shrink grid-x align-center">
        <button class="cell shrink button archetypeContainer-validate"
                (click)="onSave()"
                [disabled]="!selectedArchetype || decisionsReadonly"[i18nKey]="'decisions.archetype.choice'"></button>
    </div>
</div>
